import { useState, FormEvent } from 'react';
import '../styles/login.css';
import { signInWithEmail, getDocument } from '../firebase';
import { setLoginTime } from '../utils/sessionManager';
import { Page, f7 } from 'framework7-react';
import logo from '@assets/icon.png';
import PasswordInput from './PasswordInput';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const version = __APP_VERSION__;

  const isFormValid = email.trim() !== '' && password.trim() !== '';

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const user = await signInWithEmail(email, password);
      try {
        const snap = await getDocument(`users/${user?.uid}`);
        if (snap.exists()) {
          localStorage.setItem('userInfo', JSON.stringify(snap.data()));
          await setLoginTime();
        } else {
          localStorage.removeItem('userInfo');
        }
      } catch (err) {
        console.error('Error caching user info', err);
      }
      f7.views.main.router.navigate('/support');
    } catch {
      f7.dialog.alert('Invalid credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Page name="login" className="auth-page login-page">
      <div className="login-wrapper">
        <img src={logo} alt="Logo" className="login-logo" />

        <div className="login-title">Sign in</div>
        <div className="login-subtitle">Only members have access.</div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label htmlFor="email">Email address</label>
          <input
            id="email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label htmlFor="password">Password</label>
          <PasswordInput
            id="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div
            className="forgot-password"
            role="button"
            onClick={() => f7.views.main.router.navigate('/forgot-password')}
          >
            Forgot password
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={!isFormValid || isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>


        <div className="app-version">Version {version}</div>
      </div>
    </Page>
  );
}

export default Login;
